module.exports = __webpack_public_path__ + "img/ic_gift.661f0514.png";